<template>
  <div class="body">
    <header-top :type="selectedMenu"></header-top>
    <slot></slot>
    <footer-down></footer-down>
  </div>
</template>

<script>
import HeaderTop from "@/components/v2/Header.vue";
import FooterDown from "@/components/v2/Footer.vue";

export default {
  components: {
    HeaderTop,
    FooterDown
  },
  props: {
    selectedMenu: String
  }
};
</script>

<style scoped>
.body {
  min-height: 100vh;
  /*padding-bottom:1.8rem;*/
  position: relative;
  box-sizing: border-box;
  min-width: 1440px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/MainLayout.vue